<template>
  <b-form class="job-alerts-configure-line" @submit.prevent="() => false">
    <!-- <b-form-group :label="createLabel('departments')" v-if="departments.length">
      <multiselect id="departments" multiple :options="departments" v-model="selectedDepartment"/>
    </b-form-group> -->
    <b-form-group v-for="(choices, key) in customFields" :key="key" :label="createLabel(key)" label-cols-sm="4" label-cols-md="4">
      <multiselect id="departments" multiple :options="choices" v-model="selectedCustomFields[key]"/>
    </b-form-group>
    <b-form-group :label="createLabel('location')" label-cols-sm="4" label-cols-md="4">
      <location-search id="departments" v-model="selectedLocation"/>
      <b-form-text>Specifying a location will filter jobs within 50mi of the centre point.</b-form-text>
    </b-form-group>
  </b-form>
</template>

<script>
import _startCase from 'lodash/startCase';
import LocationSearch from '@/components/misc/LocationSearch';
import Multiselect from 'vue-multiselect';

export default {
  props: {
    value: {
      type: Object,
      required: true,
    },
    departments: {
      type: Array,
      default: () => ([]),
    },
    customFields: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    LocationSearch,
    Multiselect,
  },
  data: () => ({
    selectedDepartment: null,
    selectedLocation: null,
    selectedCustomFields: {},
  }),
  created() {
    const { location, customFields } = this.value;
    // this.selectedDepartment = department;
    this.selectedLocation = location;
    this.selectedCustomFields = customFields || {};
  },
  computed: {
    isNewField() {
      return typeof this.value.id !== 'string';
    },
  },
  methods: {
    createLabel(key) {
      return `${_startCase(key)} (Optional)`;
    },
    onFormSubmit() {
      const { value: { id: jobAlertID }, selectedDepartment, selectedLocation, selectedCustomFields } = this;
      this.$emit('input', {
        id: jobAlertID,
        department: selectedDepartment ? (({ id }) => ({ id }))(selectedDepartment) : null,
        location: selectedLocation ? (({ id }) => ({ id }))(selectedLocation) : null,
        customFields: selectedCustomFields,
      });
    },
  },
  watch: {
    selectedDepartment() {
      this.onFormSubmit();
    },
    selectedLocation() {
      this.onFormSubmit();
    },
    selectedCustomFields: {
      deep: true,
      handler() {
        this.onFormSubmit();
      },
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/job-alerts/ConfigureLine.vue